module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/sdk-summer.a9394d0f.png";